'use client';
import NotFound from '../src/views/NotFound';
export default NotFound;
